export const HIDE_HEADER = 'HIDE_HEADER'



// WEBPACK FOOTER //
// ./src/actions/header/types.js